import { Component, Emit, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import BriefingCard from '@/shared/cards/briefing/briefing-card/briefing-card.vue';
import type { IBriefingPage } from '@/shared/model/briefing-widget.model';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { namespace } from 'vuex-class';
import { checkIsGuestAccount } from '@/util/guest-util';

const briefingStore = namespace('briefingStore');

@Component({
  computed: {},
  methods: {},
  components: { 'briefing-card': BriefingCard, 'vue-custom-scrollbar': vueCustomScrollbar },
})
export default class AddSocialAgent extends Vue {
  @Prop(Boolean) readonly openModal;

  socialAgents = [];

  @Emit('close') close() {}

  @briefingStore.Getter
  public getFeaturedPages!: IBriefingPage[];

  select(item: IBriefingPage) {
    const routeData = this.$router.resolve({ path: '/my-briefing/social/' + item.bpId });
    window.open(routeData.href, '_blank');
  }

  @Watch('getFeaturedPages')
  onGetFeaturedPagesChange() {
    this.socialAgents = this.getFeaturedPages;
  }

  @Watch('openModal')
  onOpenModalChange() {
    this.socialAgents = this.getFeaturedPages;
  }
  search(e: any) {
    const { value } = e?.target;
    if (value) {
      this.socialAgents = this.socialAgents.filter(item => item.briefingPageName.toLowerCase().includes(value.toLowerCase()));
    } else {
      this.socialAgents = this.getFeaturedPages;
    }
  }

  onSelectUserSocial(agentKey: string) {
    const userKey = this.$store.getters?.userIdentity?.id;
    if (userKey === agentKey) {
      this.$router.push('/my-briefing');
    } else {
      this.$router.push(`/social-user/${agentKey}`);
    }
  }

  async handleToggleSubscribed(payload: IBriefingPage, index: number) {
    if (checkIsGuestAccount(true)) {
      return;
    }
    this.$emit('toggleSubscribed', { payload, index, routeName: 'SocialUser' });
  }
}
